import React from 'react';
import { Row, Col, CardBody } from 'reactstrap';
import { Bar } from 'react-chartjs-2';
import {
  CardProtocolsContainer,
  CardProtocolsHeaderContainer
} from './total-protocols-per-custom-fields-styles';
import FormTooltip from 'components/Inputs/FormTooltip';

export function TotalProtocolsPerCustomField({
  customFieldsData,
  calculateProtocolByCustomField
}) {
  return (
    <CardProtocolsContainer>
      <CardProtocolsHeaderContainer>
        <h5 className="h3 mb-0">
          Distribuição de Protocolos por Campos Customizados
          <FormTooltip text="Distribuição de Protocolos por Campos Customizados do Tipo Lista" />
        </h5>
      </CardProtocolsHeaderContainer>
      <CardBody>
        <Row>
          {customFieldsData?.map((field, index) => {
            const chartData = calculateProtocolByCustomField([field]);
            if (chartData.data.length > 0) {
              const options = {
                indexAxis: 'y',
                scales: {
                  x: {
                    beginAtZero: true
                  }
                },
                responsive: true,
                maintainAspectRatio: true
              };

              return (
                <Col md="6" key={index}>
                  <CardProtocolsContainer className="mb-4">
                    <CardProtocolsHeaderContainer>
                      <h6 className="h5">{chartData.title}</h6>
                    </CardProtocolsHeaderContainer>
                    <CardBody>
                      <div
                        style={{
                          maxHeight: '400px',
                          overflowY: 'auto',
                          width: '100%'
                        }}
                      >
                        <Bar
                          data={{
                            labels: chartData.labels,
                            datasets: [
                              {
                                label: chartData.title,
                                data: chartData.data,
                                backgroundColor: chartData.backgroundColor
                              }
                            ]
                          }}
                          options={options}
                        />
                      </div>
                    </CardBody>
                  </CardProtocolsContainer>
                </Col>
              );
            } else {
              return (
                <Col md="6" key={index}>
                  <CardProtocolsContainer className="mb-4">
                    <CardProtocolsHeaderContainer>
                      <h6 className="h5">{field.title}</h6>
                    </CardProtocolsHeaderContainer>
                    <CardBody>
                      <p className="text-muted">
                        Nenhum dado disponível para este campo.
                      </p>
                    </CardBody>
                  </CardProtocolsContainer>
                </Col>
              );
            }
          })}
        </Row>
      </CardBody>
    </CardProtocolsContainer>
  );
}
